import { Inject, Injectable, OnDestroy } from '@angular/core'
import { Store } from '@ngrx/store'
import { Subscription } from 'rxjs'
import { selectProject, selectProjectKeys, selectProjects, selectUser } from './state/user-context.selectors'

@Injectable({
    providedIn: 'root'
})
export class UserContextStorageService implements OnDestroy {

    user: any
    project: any
    projects: any[]
    projectKeys: string[]

    #selectUser: Subscription
    #selectProject: Subscription
    #selectProjects: Subscription
    #selectProjectKeys: Subscription

    constructor(@Inject(Store) private store: Store,
    ) {
        this.#selectUser = this.store.select(selectUser).subscribe(data => {
            this.user = data
        })

        this.#selectProject = this.store.select(selectProject).subscribe(data => {
            this.project = data
        })

        this.#selectProjects = this.store.select(selectProjects).subscribe(data => {
            this.projects = data
        })

        this.#selectProjectKeys = this.store.select(selectProjectKeys).subscribe(data => {
            this.projectKeys = data
        })
    }

    ngOnDestroy() {
        this.#selectUser?.unsubscribe()
        this.#selectProject?.unsubscribe()
        this.#selectProjects?.unsubscribe()
        this.#selectProjectKeys?.unsubscribe()
    }

    getUser(): any {
        return this.user
    }

    getProject(): any {
        return this.project
    }

    getProjects(): any {
        return this.projects
    }

    getProjectKeys(): any {
        return this.projectKeys
    }
}